export const LOAD_HANDLERS_INFO = 'LOAD_HANDLERS_INFO';
export const LOAD_HANDLER_ACCOUNTS_LIST = 'LOAD_HANDLER_ACCOUNTS_LIST';
export const RESET_HANDLERS = 'RESET_HANDLERS';
